import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "image", "counter", "prevBtn", "nextBtn", "description"];
  static values = { urls: Array, descriptions: Array, current: { type: Number, default: 0 } };

  connect() {
    this.boundKeydown = this.handleKeydown.bind(this);
    this.keydownListenerAttached = false;
  }
  disconnect() {
    if (this.keydownListenerAttached) {
      document.removeEventListener("keydown", this.boundKeydown);
      this.keydownListenerAttached = false;
    }
  }

  open(event) {
    event.stopPropagation();
    const index = parseInt(event.currentTarget.dataset.index, 10);
    this.currentValue = Number.isNaN(index) ? 0 : index;
    this.showImage();
    this.modalTarget.style.display = "block";
    setTimeout(() => this.modalTarget.classList.add("show"), 10);
    if (!this.keydownListenerAttached) {
      document.addEventListener("keydown", this.boundKeydown);
      this.keydownListenerAttached = true;
    }
  }

  close(event) {
    if (event) event.stopPropagation();
    this.modalTarget.classList.remove("show");
    setTimeout(() => {
      this.modalTarget.style.display = "none";
    }, 150);
    if (this.keydownListenerAttached) {
      document.removeEventListener("keydown", this.boundKeydown);
      this.keydownListenerAttached = false;
    }
  }

  backdropClose(event) {
    if (event.target === this.modalTarget) {
      this.close(event);
    }
  }

  next(event) {
    if (event) event.stopPropagation();
    this.currentValue = (this.currentValue + 1) % this.urlsValue.length;
    this.showImage();
  }

  prev(event) {
    if (event) event.stopPropagation();
    this.currentValue = (this.currentValue - 1 + this.urlsValue.length) % this.urlsValue.length;
    this.showImage();
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close(event);
    if (event.key === "ArrowRight") this.next();
    if (event.key === "ArrowLeft") this.prev();
  }

  showImage() {
    const desc = this.descriptionsValue[this.currentValue];

    this.imageTarget.src = this.urlsValue[this.currentValue];
    this.imageTarget.alt = desc || "";

    this.counterTarget.textContent = `${this.currentValue + 1} / ${this.urlsValue.length}`;
    const showNav = this.urlsValue.length > 1;
    this.prevBtnTarget.classList.toggle("hidden", !showNav);
    this.nextBtnTarget.classList.toggle("hidden", !showNav);

    if (desc) {
      this.descriptionTarget.textContent = desc;
      this.descriptionTarget.classList.remove("hidden");
    } else {
      this.descriptionTarget.textContent = "";
      this.descriptionTarget.classList.add("hidden");
    }
  }
}
